/**
 * The person who opened the ticket says whether the answer was good.
 */

import React, { useState } from 'react';

export default function RatingPrompt({ current, busy, onRate }) {
  const [comment, setComment] = useState(current?.comment || '');
  const [score, setScore] = useState(current?.score || '');

  function send(event) {
    event.preventDefault();
    if (score !== 'good' && score !== 'bad') return;
    onRate(score, comment);
  }

  return (
    <form className="support-rating" onSubmit={send}>
      <p className="support-meta">How did we do?</p>
      <div className="support-actions">
        <button
          type="button"
          className={`rf-btn ${score === 'good' ? 'rf-btn-primary' : 'rf-btn-secondary'}`}
          onClick={() => setScore('good')}
        >
          Good
        </button>
        <button
          type="button"
          className={`rf-btn ${score === 'bad' ? 'rf-btn-primary' : 'rf-btn-secondary'}`}
          onClick={() => setScore('bad')}
        >
          Bad
        </button>
      </div>
      <label className="rf-label" htmlFor="support-rating-comment">
        Anything we should know? Optional.
        <textarea
          id="support-rating-comment"
          className="rf-input"
          rows={2}
          maxLength={2000}
          value={comment}
          onChange={(event) => setComment(event.target.value)}
        />
      </label>
      <button type="submit" className="rf-btn rf-btn-primary" disabled={busy || !score}>Send rating</button>
    </form>
  );
}
